export const STORY_SCENES = [
  {
    key: "menu",
    step: "۰۱",
    eyebrow: "منوی دیجیتال",
    title: "منویی که با برند شما زندگی می‌کند",
    highlight: "برند شما",
    description:
      "دسته‌بندی‌ها، تصویرها و قیمت‌ها در یک تجربه سریع و خوانا برای مشتری.",
  },
  {
    key: "customize",
    step: "۰۲",
    eyebrow: "شخصی‌سازی",
    title: "هویت رستوران، داخل خود منو",
    highlight: "هویت رستوران",
    description:
      "رنگ، قالب، دسته‌بندی و نشان رستوران را بدون کدنویسی تنظیم کنید.",
  },
  {
    key: "qr",
    step: "۰۳",
    eyebrow: "QR اختصاصی",
    title: "از ساخت منو تا اسکن روی میز",
    highlight: "اسکن روی میز",
    description:
      "برای هر میز QR بسازید و مشتری را مستقیم به منوی به‌روز برسانید.",
  },
  {
    key: "reserve",
    step: "۰۴",
    eyebrow: "رزرو آنلاین",
    title: "رزرو، درست کنار تجربه منو",
    highlight: "رزرو",
    description:
      "تاریخ، ساعت، تعداد مهمان و میز را انتخاب و رزرو را همان‌جا تأیید کنید.",
  },
  {
    key: "dashboard",
    step: "۰۵",
    eyebrow: "مدیریت یکپارچه",
    title: "تمام رستوران در یک نمای عملیاتی",
    highlight: "یک نمای عملیاتی",
    description:
      "منو، رزرو، میزها و سفارش‌ها را از یک داشبورد کنترل کنید.",
  },
];

export const STORY_PROGRESS = [
  { key: "menu", start: 0, end: 0.18 },
  { key: "customize", start: 0.18, end: 0.38 },
  { key: "qr", start: 0.38, end: 0.58 },
  { key: "reserve", start: 0.58, end: 0.78 },
  { key: "dashboard", start: 0.78, end: 1 },
];

// Where each scene is fully settled: the timeline holds still around these
// points, so ScrollTrigger snaps a released scroll to one of them.
export const STORY_SNAP_POINTS = [0, 0.28, 0.48, 0.7, 1];

export const getStorySceneAtProgress = (progress) => {
  const numericProgress = Number(progress);
  const clamped = Number.isFinite(numericProgress)
    ? Math.min(1, Math.max(0, numericProgress))
    : 0;
  const range =
    STORY_PROGRESS.find(({ end }) => clamped <= end) ||
    STORY_PROGRESS[STORY_PROGRESS.length - 1];

  return STORY_SCENES.find(({ key }) => key === range.key);
};

export const getStoryScrollDistance = (mode, viewportHeight) => {
  const multiplier = mode === "desktop" ? 5 : mode === "tablet" ? 4 : 0;
  return Math.round(Math.max(0, Number(viewportHeight) || 0) * multiplier);
};
